export default "__VITE_ASSET__ErJSnKRu__"